import { render, staticRenderFns } from "./LocationItems.vue?vue&type=template&id=58f0d57b&scoped=true"
import script from "./LocationItems.vue?vue&type=script&lang=ts"
export * from "./LocationItems.vue?vue&type=script&lang=ts"
import style0 from "./LocationItems.vue?vue&type=style&index=0&id=58f0d57b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f0d57b",
  null
  
)

export default component.exports